import Form from './container'
import FormInput from './components/formInput'
import FormButton from './components/formButton'

export default Form
export { FormInput, FormButton }
